import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { environment } from '@environment';
import { AppModule } from './app/app.module';

const script = document.createElement('script');
script.src = environment.jackpotSDKUrl;
script.async = true;
script.onerror = (error) => {
  console.error('Jackpot Lib load error', error);
};
script.onload = () => {
  console.log('Jackpot Lib loaded successfully');
};
document.head.appendChild(script);

platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
